import React from "react";

export default function Footer(props) {
  if (!props.data) return null;

  const networks = props.data.social.map(function (network) {
    return (
      <li key={network.name}>
        <a target="blank" className="shadow-md" href={network?.url}>
          <span className="fa-stack fa-sm">
            <i className="fas fa-circle fa-stack-2x"></i>
            <i className={`fab ${network?.className} fa-stack-1x fa-inverse`}></i>
          </span>
        </a>
      </li>
    );
  });

  return (
    <footer>
      <div className="row">
        <div className="twelve columns">
          <ul className="social-links" id="social">
            {networks}
          </ul>

          <ul className="copyright text-white font-Oxygenbold">
            <li>&copy; Copyright {new Date().getFullYear()} Malik</li>
          </ul>
        </div>

        <div id="go-top">
          <a className="smoothscroll" title="Back to Top" href="#home">
            <i className="icon-up-open"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}
